import { LinkOutlined, UploadOutlined } from '@ant-design/icons'
import { Flex, message, Popover, Space, Typography } from 'antd'
import * as React from 'react'

const { Link, Text } = Typography

interface LinkInTextProps {
  text?: string
}

const urlPattern = /(https?:\/\/[^\s]+)/g

export const LinkInText = ({ text }: LinkInTextProps) => {
  const isUrl = (word: string): RegExpMatchArray | null => {
    return word.match(urlPattern)
  }

  const text_array = text?.split(urlPattern)

  const handleCopy = (url: string): void => {
    navigator.clipboard.writeText(url)
    message.info('Copied to clipboard.')
  }
  const handleOpen = (url: string): void => {
    window.open(url, '_blank', 'noreferrer')
  }

  const addMarkup = (word: string): string | React.ReactElement => {
    return isUrl(word) ? (
      <Popover
        placement="bottom"
        trigger="click"
        title={
          <Flex justify="space-between" gap={16}>
            <Text>{word}</Text>

            <Space>
              <LinkOutlined
                title="Copy to clipboard"
                onClick={() => handleCopy(word)}
              />

              <UploadOutlined
                title="Open in new tab"
                onClick={() => handleOpen(word)}
              />
            </Space>
          </Flex>
        }
      >
        <Link>{word}</Link>
      </Popover>
    ) : (
      word
    )
  }

  return <div>{text_array?.map((w) => addMarkup(w))}</div>
}
